module.exports = __webpack_public_path__ + "static/media/Logo.fba1cd67.svg";